<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">回款认领</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
			<Claim v-if="activeIndex == 'list'" ></Claim>
      </div>
    </div>
  </div>
</template>

<script>
import Claim from './claim.vue';//回款认领
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
	  id:'',
    };
  },
  components: {
	Claim,
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  
  methods: {
    handleSelect(key, keyPath) {
		console.log(key, keyPath)
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
  },
};
</script>